// @ts-check

/**
 * Event the form-aware registration wrapper dispatches from the native
 * `formDisabledCallback` so a component can react to its disabled state
 * (own attribute presence and ancestor `<fieldset disabled>`) without the
 * wrapper mutating the host.
 *
 * Kept in this dependency-free module so the registration layer can reference
 * it without importing the `useFormControl` composable (and its Vue/VueUse deps).
 */
export const FORM_DISABLED_EVENT = "sp:form-disabled";

/**
 * Event the wrapper dispatches from the native `formResetCallback` so a
 * component can restore the state its attributes describe when its form is
 * reset.
 */
export const FORM_RESET_EVENT = "sp:form-reset";

/**
 * Dispatched on the host when its custom validation error is set or cleared, carrying the message
 * in `detail`. The wrapper is the only writer, so a component reads the current error from here
 * rather than keeping a copy of its own.
 */
export const CUSTOM_VALIDITY_EVENT = "sp:custom-validity";

/**
 * Dispatched on the host for any `name` write — the property, `setAttribute` under any casing, and
 * `removeAttribute`, which carries `""`. `detail` holds the attribute's value after the write. A
 * control that builds its own FormData rebuilds it from here, in the same task as the write, the
 * way a native reflected `name` moves its entry.
 */
export const NAME_CHANGED_EVENT = "sp:name-changed";

// Dispatched on a registered element whose Vue instance survives a move out of and back into the
// document (Vue itself runs nothing on that reconnection).
export const RECONNECTED_EVENT = "sp:reconnected";
